const styles = theme => ({

  tutorialScreenContainer: {
    height: '100vh',
    backgroundColor: '#565656'
  },

  tutorialTitle: {
    color: '#fff',
    fontSize: '35px',
    fontWeight: '500',
    padding: '25px 20px 0 20px',
    fontFamily: "'Oswald', sans-serif",
  },

  homeQuestion: {
    color: '#003e4c',
    fontFamily: 'Oswald',
    fontSize: '45px',
    fontWeight: '500'
  },

  gdpIcon: {
    width: '450px',
    height: '240px',
    margin: '50px 0'
  },

  gotItButton: {
    backgroundColor: '#00b1d9',
    color: '#fff',
    fontSize: "30px",
    fontWeight: "500",
    padding: "0 30px",
    borderRadius: '6px',
    margin: '24px 0',
    fontFamily: "'Oswald', sans-serif",
    "&:hover": {
      backgroundColor: "#056f8a",
    },
  },

  bearIcon: {
    width: '150px',
    height: '150px'
  }

})

export default styles
